__turbopack_context__.v({
  "className": "LGqh7G_className",
  "variable": "LGqh7G_variable",
});
